import { render } from "./MenuQuiz.vue?vue&type=template&id=09bd55ec&scoped=true"
import script from "./MenuQuiz.vue?vue&type=script&lang=js"
export * from "./MenuQuiz.vue?vue&type=script&lang=js"

import "./MenuQuiz.vue?vue&type=style&index=0&id=09bd55ec&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src821934687/src/cuco-prova-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bd55ec"]])

export default __exports__